import { Box, Flex, Icon, Text } from '@chakra-ui/react';

import { formatFileType } from '../../utils/formatFileType';

import CloseIcon from './assets/close.svg?react';
import { getFileIcon } from './fileIconUtils';

const MAX_FILENAME_LENGTH = 14;

function truncateFilename(filename: string): string {
  if (filename.length <= MAX_FILENAME_LENGTH) {
    return filename;
  }

  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex === -1 || lastDotIndex === 0) {
    return `${filename.substring(0, MAX_FILENAME_LENGTH - 3)}...`;
  }

  const extension = filename.substring(lastDotIndex);
  const nameWithoutExtension = filename.substring(0, lastDotIndex);

  if (extension.length > 6) {
    return `${nameWithoutExtension.substring(0, MAX_FILENAME_LENGTH - 3)}...`;
  }

  const charsToKeep = MAX_FILENAME_LENGTH - extension.length - 3;

  const truncatedName = nameWithoutExtension.substring(0, Math.max(1, charsToKeep));

  return `${truncatedName}...${extension}`;
}

export function FilePreview({ file, onRemove }: { file: File; onRemove: VoidFunction }) {
  const renderFileIcon = () => getFileIcon(file.type);

  const truncatedName = truncateFilename(file.name);
  const fileType = formatFileType(file.type);

  return (
    <Flex
      alignItems="center"
      bg="gray.100"
      gap={2}
      px={'6px'}
      py={'10px'}
      borderRadius="6px"
      w="118px"
      h={12}
      pos={'relative'}
    >
      <Box flexShrink={0}>{renderFileIcon()}</Box>
      <Box>
        <Text fontSize="10px" color="greyscale.950" mb={'2px'} w="full">
          {truncatedName}
        </Text>
        <Text fontSize="8px" lineHeight="9.6px" color="greyscale.800">
          {fileType}
        </Text>
      </Box>
      <Icon
        bg="greyscale.100"
        rounded={'full'}
        pos={'absolute'}
        top="-7px"
        right="-4px"
        cursor={'pointer'}
        boxSize={'16px'}
        stroke="greyscale.950"
        onClick={onRemove}
        border="1px solid"
        borderColor={'white'}
      >
        <CloseIcon />
      </Icon>
    </Flex>
  );
}
